export const primary = "#182a88";
export const secondary = "#35c0d5";
export const secondaryDark = "#182a88";
export const secondaryLight = "#35c0d5";
export const danger = "#ff4136";
export const white = "#FFFFFF";
export const background = "#f7f7f7";
export const backgroundDark = "#eff0f7";
export const colgate = "#fff";
export const textPrimary = "#182a88";
export const textError = "#cb3535";
export const textSuccess = "#008000";
export const textMuted = "rgb(24 42 136 / 40%)";
export const successGreen = "#56db8b";
export const lightPurple = "7FA2EA";
export const chatUser = "#EEF0F7";
export const chatClient = "rgb(24 42 136 / 7%)";
export const aliceBlue = "#f2f6fd";
export const axolotl = "#657e47";
export const sonicSilver = "#797979";
export const soldierGreen = "#4e6137";
export const brightGray = "#ECEFF6";
export const indigo = "#1d2c63";
export const electricGreen = "#00DF09";
export const coralReef = "#F87B6A";
export const magenta = "#FF00FF";
export const lightBlue = "#7FA2EA";
export const Red = "#C73031";
export const Orange = "#E58F43";
export const Green = "#37614A";
export const lightOrange = "#EA7C5B";
export const lightRed = "#FFCCCC";
export const utilityError = "#FF4444";
export const successIcon = "#007E33";
export const lightSilver = "#d2d5e0";
export const mistyRose = "#FFE5E5";
export const utilityWarning = "#FFBB33";
export const utilitySuccess = "#00C851";
export const slateBlue = "#6164C1";
export const proSuccess = "#00C2CE";
export const ghostWhite = "#F9FBFF";
export const chatDark = "#e7e9f0";
export const mountbattenPink = "#9E718A";
export const lightPink = "#FDF0F0";

export const SUCCESS_GREEN_100 = "#E3F5EB";
export const SUCCESS_GREEN_500 = "#37614A";
export const SUCCESS_GREEN_600 = "#5C8F73";
export const SUCCESS_GREEN_800 = "#35664B";

export const ERROR_RED_100 = "#FFE3E3";
export const ERROR_RED_300 = "#F08586";
export const ERROR_RED_400 = "#E85A5C";
export const ERROR_RED_500 = "#C73031";
export const ERROR_RED_600 = "#A60F0F";
export const ERROR_RED_700 = "#E74346";
export const ERROR_RED_800 = "#C2292C";

export const BLACK_TRANSPARENT = "#00000066";

export const GREEN_100 = "#e9efe2";
export const GREEN_200 = "#DBE7CC";
export const GREEN_400 = "#59876E";
export const GREEN_500 = "#869A6D";
export const GREEN_700 = "#657e47";
export const GREEN_800 = "#4e6137";

export const MOSS_GREEN_100 = "#EDF5E3";
export const MOSS_GREEN_200 = "#DBE7CC";
export const MOSS_GREEN_300 = "#C4D4B2";
export const MOSS_GREEN_400 = "#AFC199";
export const MOSS_GREEN_500 = "#9AAD82";
export const MOSS_GREEN_600 = "#7C9A57";
export const MOSS_GREEN_800 = "#607447";
export const MOSS_GREEN_900 = "#4E6137";

export const SECONDARY_RED_500 = "#993D3D";

export const SECONDARY_AMBER_500 = "#99633D";

export const SECONDARY_BLUE_200 = "#B9E0FF";
export const SECONDARY_BLUE_500 = "#406080";

export const SECONDARY_TEAL_500 = "#338066";

export const SECONDARY_YELLOW_500 = "#99773D";

export const SECONDARY_PURPLE_500 = "#5F4D80";

export const DAVYS_GREY_100 = "#FFFFFF";
export const DAVYS_GREY_200 = "#F7F7F7";
export const DAVYS_GREY_300 = "#EEEEEE";
export const DAVYS_GREY_400 = "#e0e0e0";
export const DAVYS_GREY_500 = "#BDBDBD";
export const DAVYS_GREY_600 = "#9E9E9E";
export const DAVYS_GREY_700 = "#757575";
export const DAVYS_GREY_800 = "#4C4C4C";
export const DAVYS_GREY_900 = "#333333";

export const BRICK_TERRACOTA_100 = "#FFF5F2";
export const BRICK_TERRACOTA_200 = "#FFE9E3";
export const BRICK_TERRACOTA_400 = "#F7BCAA";
export const BRICK_TERRACOTA_500 = "#F3A78F";
export const BRICK_TERRACOTA_800 = "#E76943";
export const BRICK_TERRACOTA_900 = "#D4532C";

export const BUTTERSCOTCH_100 = "#FFF9E3";
export const BUTTERSCOTCH_200 = "#F7E3AB";
export const BUTTERSCOTCH_400 = "#FFCB63";
export const BUTTERSCOTCH_500 = "#E5A443";
export const BUTTERSCOTCH_600 = "#B27210";
export const BUTTERSCOTCH_900 = "#B27210";

export const PICTON_BLUE_100 = "#E3F2FF";
export const PICTON_BLUE_200 = "#B3D9F7";
export const PICTON_BLUE_300 = "#85C0F0";
export const PICTON_BLUE_400 = "#5AA9E8";
export const PICTON_BLUE_600 = "#255780";

export const DUSTY_ORANGE_200 = "#FFCAB0";
export const DUSTY_ORANGE_400 = "#FFAC63";
export const DUSTY_ORANGE_500 = "#E58F43";
export const DUSTY_ORANGE_600 = "#E59B5A";
export const DUSTY_ORANGE_700 = "#804f18";
export const DUSTY_ORANGE_800 = "#D6842D";

export const ACCENT_100 = "#FFFFFF";
export const ACCENT_200 = "#FAFAFA";
export const ACCENT_300 = "#F7F7F7";
export const ACCENT_400 = "#EFEFEF";
export const ACCENT_500 = "#D2D2D2";
export const ACCENT_600 = "#A5A5A5";
export const ACCENT_700 = "#797979";
export const ACCENT_800 = "#4C4C4C";
export const ACCENT_900 = "#333333";

export const PRIMARY_900 = "#D4532C";
export const PRIMARY_800 = "#E76943";
export const PRIMARY_700 = "#EA7C5B";
export const PRIMARY_600 = "#ED8F72";
export const PRIMARY_500 = "#F0A18A";
export const PRIMARY_400 = "#F3B4A1";
export const PRIMARY_300 = "#F6C7B9";
export const PRIMARY_200 = "#F9DAD0";
export const PRIMARY_100 = "#FCECE8";

export const SECONDARY_000 = "#ECF7FE";
export const SECONDARY_100 = "#D8EFFD";
export const SECONDARY_200 = "#B1DFFB";
export const SECONDARY_300 = "#8ACFF9";
export const SECONDARY_400 = "#63BFF8";
export const SECONDARY_500 = "#3BAFF6";
export const SECONDARY_600 = "#159FF4";
export const SECONDARY_700 = "#0A88D6";
export const SECONDARY_800 = "#086FAF";
export const SECONDARY_900 = "#065788";

export const PLUM_PURPLE_100 = "#F7F0FF";
export const PLUM_PURPLE_500 = "#665280";
export const PLUM_PURPLE_700 = "#725694";
export const PLUM_PURPLE_800 = "#624585";
export const OLD_MAUVE_100 = "#FFF0F8";
export const OLD_MAUVE_500 = "#80526B";
export const OLD_MAUVE_600 = "#B27296";

export const WHEAT = "#F5DEB0";
export const TEA_GREEN = "#CEF5BA";
export const LAVENDER_BLUE = "#C4D4F5";
export const PALE_PURPLE = "#EBE3F5";
export const MAGIC_MINT = "#B0E8C9";
export const LIGHT_GREEN = "#E3F5EB80";
export const LIGHT_BLUE = "#E3F2FF80";

// Updated colors as per the new design system

// Neutral Color

export const DAVYS_GREY = {
  100: "#FFFFFF",
  200: "#F7F7F7",
  300: "#EEEEEE",
  400: "#E0E0E0",
  500: "#BDBDBD",
  600: "#9E9E9E",
  700: "#757575",
  800: "#4C4C4C",
  900: "#333333",
  1000: "#212121",
};

// Primary Colors

export const BRICK_TERRACOTA = {
  100: "#FFF5F2",
  200: "#FFE9E3",
  300: "#FBD3C6",
  400: "#F7BCAA",
  500: "#F3A78F",
  600: "#EF9175",
  700: "#EB7D5C",
  800: "#E76943",
  900: "#D4532C",
  1000: "#BF3F19",
};

export const DARK_MOSS_GREEN = {
  100: "#EDF5E3",
  200: "#DBE7CC",
  300: "#C4D4B2",
  400: "#AFC199",
  500: "#9AAD82",
  600: "#869A6D",
  700: "#728759",
  800: "#607447",
  900: "#4E6137",
  1000: "#394725",
};

// Utility Colors

export const ERROR_RED = {
  100: "#FDF0F0",
  200: "#FAD9DA",
  300: "#F6BBBC",
  400: "#F39D9F",
  500: "#EF7F81",
  600: "#EB6164",
  700: "#E74346",
  800: "#C2292C",
  900: "#A81619",
  1000: "#780607",
};

export const SUCCESS_GREEN = {
  100: "#E6F5ED",
  200: "#C9E4D6",
  300: "#AACFBB",
  400: "#8DBAA2",
  500: "#74A589",
  600: "#5C8F73",
  700: "#477A5E",
  800: "#35664B",
  900: "#26533A",
  1000: "#193F2A",
};

// Secondary Colors

export const DUSTY_ORANGE = {
  100: "#FFF7F1",
  200: "#FFEADB",
  300: "#FFDBBE",
  400: "#FFCBA1",
  500: "#FFBF84",
  600: "#FFB067",
  700: "#EB9A44",
  800: "#D6842D",
  900: "#AD6916",
  1000: "#854C07",
};

export const BUTTERSCOTCH = {
  100: "#FFFCF1",
  200: "#FFF8DB",
  300: "#FFF0BE",
  400: "#FFE9A1",
  500: "#FFDE84",
  600: "#FFD667",
  700: "#EBB944",
  800: "#D6A32D",
  900: "#AD7B16",
  1000: "#855B07",
};

export const PICTON_BLUE = {
  100: "#F0F7FD",
  200: "#DBEEFC",
  300: "#BBDCF7",
  400: "#9DCDF3",
  500: "#7FBEEF",
  600: "#61AEEC",
  700: "#439FE8",
  800: "#297FC3",
  900: "#15519E",
  1000: "#064679",
};

export const PLUM_PURPLE = {
  100: "#F7F0FF",
  200: "#E0D3F0",
  300: "#CAB8E0",
  400: "#B59FD1",
  500: "#A288C2",
  600: "#8F72B2",
  700: "#725694",
  800: "#624585",
  900: "#523675",
  1000: "#442966",
};

export const OLD_MAUVE = {
  100: "#FFF0F8",
  200: "#F0D3E3",
  300: "#E0B8CE",
  400: "#D19FBB",
  500: "#C288A8",
  600: "#B27296",
  700: "#945678",
  800: "#854568",
  900: "#753659",
  1000: "#66294A",
};

export const RIVER_BED = {
  100: "#F0F8FF",
  200: "#D5E5F2",
  300: "#BAD1E3",
  400: "#9FBBD1",
  500: "#84A3BD",
  600: "#6C8DA8",
  700: "#567894",
  800: "#426480",
  900: "#31516B",
  1000: "#233F57",
};
